<template lang="html">
  <b-container
    v-if="
      $store.state.stripe_card_expired &&
        autoRenewalEnabled &&
        !$route.meta.hideNav
    "
    class="mt-3"
  >
    <b-row>
      <b-col md="12">
        <b-alert dismissible variant="info" show>
          Your account's credit card has expired. Please review your
          <b-link :to="{ name: 'account' }">account settings</b-link> now.
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "CardUpdateNeeded",
  data() {
    return {};
  },
  computed: {
    autoRenewalEnabled() {
      return (
        (this.$store.state.user_doc.stripe_result || {}).cancel_at_period_end ==
        false
      );
    }
  }
};
</script>

<style lang="css" scoped></style>
